<template>
  <div>
    <BreadCrumb>
      <BreadCrumbItem style="display: inline-block">
        <router-link to="/dashboard" class="breadcrumb-link">
          {{ $t("sidebar.dashboard") }}
        </router-link>
      </BreadCrumbItem>

      <BreadCrumbItem style="display: inline-block">
        <router-link to="/orders" class="breadcrumb-link">
          Documents
        </router-link>
      </BreadCrumbItem>

      <BreadCrumbItem style="display: inline-block">
        <span class="breadcrumb-current">{{
            `Order #${order ? order?.order_id : ""}`
          }}</span>
      </BreadCrumbItem>
    </BreadCrumb>

    <el-dialog
      title="Content review request"
      :visible.sync="dialogRequestReview"
    >
      <ValidationObserver v-slot="{ handleSubmit, valid }">
        <form @submit.prevent="handleSubmit(humanOrderDelivered('review'))">
          <div>
            <ValidationProvider rules="required">
              <base-textarea
                :label="'Why are you requesting a review? Indicate the reasons for the review'"
                type="text"
                :placeholder="'Enter a reason'"
                v-model="form.reject_note"
              >
              </base-textarea>
            </ValidationProvider>
            <SubmitButton :text="'Request a review'" :isDisabled="!valid" />
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>

    <el-dialog title="Reject this article" :visible.sync="dialogReject">
      <ValidationObserver v-slot="{ handleSubmit, valid }">
        <form @submit.prevent="handleSubmit(humanOrderDelivered('reject'))">
          <div>
            <label
            >You are decided to reject this content. Please tell us your
              reason for rejecting this article</label
            >
            <ValidationProvider rules="required">
              <base-textarea
                :label="'Please tell us your reason for rejecting this article'"
                type="text"
                :placeholder="'Enter a reason'"
                v-model="form.reject_note"
              >
              </base-textarea>
            </ValidationProvider>
            <SubmitButton :text="'Reject content'" :isDisabled="!valid" />
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>

    <el-dialog
      :title="'Edit Type'"
      :visible="editFieldName === 'type'"
      class="dialog-sm"
    >
      <el-select v-model="editFieldValue" class="select-primary" size="medium">
        <el-option class="select-primary" value="new" :label="$t('taskAssignment.action.options.new')" />
        <el-option class="select-primary" value="add"
          :label="$t('taskAssignment.action.options.add')" />
        <el-option class="select-primary" value="rewrite"
          :label="$t('taskAssignment.action.options.rewrite')" />
        <el-option class="select-primary" value="edit"
          :label="$t('taskAssignment.action.options.edit')" />
      </el-select>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Project ID'"
      :visible="editFieldName === 'project_id'"
      class="dialog-sm"
    >
      <base-input
        type="text"
        v-model="editFieldValue"
      >
      </base-input>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Task Description'"
      :visible="editFieldName === 'task_description'"
      class="dialog-sm"
    >
      <base-textarea
        type="text"
        v-model="editFieldValue"
      >
      </base-textarea>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Additional Content'"
      :visible="editFieldName === 'additional_content'"
      class="dialog-sm"
    >
      <EditorLight v-model="editFieldValueHtml"></EditorLight>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Content Length'"
      :visible="editFieldName === 'content_length'"
      class="dialog-sm"
    >
      <el-select v-model="editFieldValue" class="select-primary" size="medium">
        <el-option class="select-primary" value="350" label="350" />
        <el-option class="select-primary" value="500" label="500" />
        <el-option class="select-primary" value="700" label="700" />
        <el-option class="select-primary" value="900" label="900" />
      </el-select>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Product Category Name'"
      :visible="editFieldName === 'category_name'"
      class="dialog-sm"
    >
      <base-input
        type="text"
        v-model="editFieldValue"
      >
      </base-input>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Soft Keywords'"
      :visible="editFieldName === 'soft_keywords'"
      class="dialog-sm"
    >
      <div class="input_with_btn">
        <BaseInput :label="$t('CategoryCards.soft_keywords.label')"
          :tooltip="$t('CategoryCards.soft_keywords.tooltip')" type="text" :optional="true"
          :placeholder="$t('CategoryCards.soft_keywords.placeholder')" v-model="soft_keyword"
          @keyup.enter="addSoftKeyword(soft_keyword)">
        </BaseInput>
        <base-button slot="reference" icon size="sm" class="btn-simple mb-n1"
          @click.prevent="addSoftKeyword(soft_keyword)">
          <div>
            <i class="fa-solid fa-plus"></i>
          </div>
        </base-button>
      </div>
      <div class="mt-n2 ml-1">
        <div class="bulk-file-list d-flex">
          <span v-for="sk in soft_keywords" :key="sk" class="seo_article__p">
            {{ sk }}
            <i @click.prevent="removeSoftKeyword(sk)" class="fa-regular fa-xmark seo_article__asterisk"></i>
          </span>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Headings'"
      :visible="editFieldName === 'headings'"
      class="dialog-sm"
    >
      <div class="input_with_btn">
        <BaseInput :label="$t('CategoryCards.headings.label')" :tooltip="$t('CategoryCards.headings.tooltip')"
          type="text" :optional="true" :placeholder="$t('CategoryCards.headings.placeholder')"
          v-model="heading2" @keyup.enter="addH2(heading2)">
        </BaseInput>
        <base-button slot="reference" icon size="sm" class="btn-simple mb-n1"
          @click.prevent="addH2(heading2)">
          <div>
            <i class="fa-solid fa-plus"></i>
          </div>
        </base-button>
      </div>
      <div class="mt-n2 ml-1">
        <div class="bulk-file-list d-flex">
          <span v-for="h2 in headings" :key="h2" class="seo_article__p">
            {{ h2 }}
            <i @click.prevent="removeH2(h2)" class="fa-regular fa-xmark seo_article__asterisk"></i>
          </span>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-6 pr-2">
          <base-button
            @click.prevent="handleEditFieldResetDialog"
            type="primary"
            class="btn-fill btn_add_link px-3 mt-0 w-100"
          >
            Cancel
          </base-button>
        </div>
        <div class="col-6 pl-2">
          <base-button
            @click.prevent="handleUpdateField"
            native-type="submit"
            type="primary"
            class="btn-fill btn_submit_form px-3 mt-0 w-100"
          >Save
          </base-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'Edit Page Url'"
      :visible.sync="showPageUrlDialogVisible"
      class="dialog-lg"
    >
      <PageUrlCreateForm
        :updatingPageUrl="showPageUrlDialogPageUrl"
        :key="showPageUrlDialogComponentKey"
        @hideForm="handleHidePageUrlDialog"
        @urlChanged="handleChangedPageUrl"
      />
    </el-dialog>

    <div>
      <div v-if="isOrderDelivered" class="order__button-wrapper">
        <h4 class="mb-0">Waiting on your approval!</h4>
        <label class="mb-0"
        >Your content has been delivered. You can accept or reject the work
          done.</label
        >
        <div
          class="order-detail__creators-button prc-btn justify-content-start pb-0 mb-0"
        >
          <base-button
            @click="humanOrderDelivered('accept')"
            native-type="submit"
            type="primary"
            class="btn-fill ml-3 my-0 py-3 px-3 btn_submit_form btn_save btn_save__add_member"
          >
            Approve
          </base-button>

          <base-button
            v-if="!order?.rejectet_num"
            @click="dialogRequestReview = true"
            native-type="submit"
            type="primary"
            class="btn-fill ml-3 my-0 py-3 px-3 btn_submit_form btn_save btn_save__add_member"
          >
            Require a review
          </base-button>
          <base-button
            v-else
            @click="dialogReject = true"
            native-type="submit"
            type="primary"
            class="btn-fill ml-3 my-0 py-3 px-3 btn_submit_form btn_save btn_save__add_member"
          >
            Reject order
          </base-button>
        </div>
      </div>

      <div v-if="isAdminStatus" class="order__button-wrapper">
        <h4 class="mb-0">Refund or reschedule order</h4>
        <div
          class="order-detail__creators-button prc-btn justify-content-start pb-0 mb-0"
        >
          <base-button
            @click="humanOrderDelivered('refund')"
            native-type="submit"
            type="primary"
            class="btn-fill ml-3 my-0 py-3 px-3 btn_submit_form btn_save btn_save__add_member"
          >
            Refund
          </base-button>

          <base-button
            @click="humanOrderDelivered('reschedule')"
            native-type="submit"
            type="primary"
            class="btn-fill ml-3 my-0 py-3 px-3 btn_submit_form btn_save btn_save__add_member"
          >
            Reschedule order
          </base-button>
        </div>
      </div>
    </div>

    <div
      v-if="loaded"
      class="row pb-0"
      :class="task && isSticky ? 'mt-n3' : ''"
    >
      <div
        :class="[
          'col-lg-9 border-card content-pane',
          task ? 'scrollable pt-lg-3 pb-lg-0' : '',
          task && isSticky ? 'sticky-card' : '',
        ]"
      >
        <card>
          <div class="row">
            <div
              class="col-md-12 d-lg-flex align-items-center justify-content-between"
            >
              <h4 v-if="statusLabel == 'Accepted'" class="card-title">
                <span v-if="!task"> Generated Result </span>
                <span v-else> Editor </span>
              </h4>
              <div v-if="order?.content" class="d-flex align-items-center">
                <ContentToolbar
                  :showVersionHistory="true"
                  :show-link-builder="
                    !getUserExtraInfo?.hide_generic_link_builder &&
                    selectedWorkspace.id !== null
                  "
                  @saved="onOrderSavedManually"
                  @showDialog="isSticky = !$event"
                  @toggleLinkBuilder="toggleLinkBuilder = !toggleLinkBuilder"
                />
              </div>
            </div>
            <div v-if="!task" class="col-md-12 mt-4">
              <div class="row">
                <div class="col-md-3">
                  <label class="">Order ID</label>
                  <p>{{ order?.order_id }}</p>
                </div>
                <div class="col-md-3">
                  <label class="">Tool</label>
                  <p>{{ order?.product }}</p>
                </div>
                <div class="col-md-3">
                  <label class="">Created</label>
                  <p>{{ createdAt }}</p>
                </div>
                <div class="col-md-3">
                  <label class="">Order Status</label>
                  <div class="d-flex align-items-center mb-1" style="gap: 10px">
                    <div :class="['status', `status__${status}`]"></div>
                    <p class="m-0">{{ statusLabel }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="order?.title" class="seo_article mt-3">
            <div class="gen-art-left">
              <input class="mb-0" type="text" v-model="order.title" />
            </div>
          </div>

          <div class="row mt-4" v-if="!toggleLinkBuilder">
            <div class="col">
              <component
                v-if="contentComponentName"
                :is="contentComponentName"
                @contentChanged="autosaveCheckDirty"
              />
            </div>
          </div>

          <SelectableText
            v-else
            :text="order?.content"
            v-on:text-selected="handleKeywordSelected"
          />

          <TaskAssignmentMetaData
            v-if="task"
            :order="order"
            :task="task"
            :history="taskHistory"
          >
          </TaskAssignmentMetaData>
        </card>
      </div>

      <div
        :class="[
          'col-lg-3 sidebar-content',
          task ? 'scrollable pt-lg-3 pb-lg-0 mb-0' : '',
          task && isSticky ? 'sticky-card' : '',
        ]"
      >
        <TaskAssignmentReview></TaskAssignmentReview>

        <LinkBuilder
          v-if="
            toggleLinkBuilder &&
            !getUserExtraInfo?.hide_generic_link_builder &&
            selectedWorkspace.id !== null
          "
          @exit-link-builder="toggleLinkBuilder = false"
        />

        <TextCounter
          v-if="
            contentComponentName == 'TextContent' &&
            order?.json_data?.api_input?.content_length
          "
          :content="order.content"
          :max-content-length="order?.json_data?.api_input?.content_length"
        >
        </TextCounter>

        <TaskAssignment
          v-if="task"
          :order="order"
          :task="task"
          :history="taskHistory"
          @showDialog="isSticky = !$event"
          @showPageUrlDialog="handleShowPageUrlDialog($event)"
          @updateEditField="($name, $value) => handleEditFieldShowDialog($name, $value)"
        >
        </TaskAssignment>

        <TrentinoRegenerationSidebar
          v-if="order && isTrentinoTool && order.json_data && (order.language === 'it' || order.json_data.languages === 'it' || order.json_data.translate_from === 'it')"
          :product-key="order.product_key"
          :json-data="order.json_data"
          :order-detail-id="order.order_detail_id"
          :product-keys="currentInfoTool?.product_keys?.[0] ?? []"
          @regenerated="onRegenerated"
        />

        <div v-if="order && currentInfoTool?.translation && order.product_key !== 'microcopy_social'">
          <TranslationSidebar
            v-if="order.language === 'it' && showSidebarTranslation"
            :order="order"
            :infoTool="currentInfoTool"
          />

          <div v-else>
            <div class="notice">
              <div class="notice-icon">
                <i class="fa-regular fa-1x fa-triangle-exclamation"></i>
              </div>
              <div class="notice-text">
                <strong>You're viewing a translated version</strong><br>
                This content was originally generated in Italian language and then translated.<br>
                <router-link
                  v-if="originalOrderDetailId"
                  target="_blank"
                  :to="`/orders/${originalOrderDetailId}`"
                >
                  {{ 'Open original file' }}
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <UserComments
          v-show="userCanUseComments"
          @show-component="showCommentsComponent = true"
        >
        </UserComments>
      </div>
    </div>
    <div v-else v-loading="!loaded" class="row mt-lg"></div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/Breadcrumb/Breadcrumb";
import BreadCrumbItem from "@/components/Breadcrumb/BreadcrumbItem";
import AudioContent from "./AudioContent";
import ImageContent from "./ImageContent";
import TextContent from "./TextContent.vue";
import VideoContent from "./VideoContent.vue";
import ContentToolbar from "@/pages/Components/ContentToolbar.vue";
import orderAutosave from "@/mixins/orderAutosave";
import TaskAssignment from "./TaskAssignment.vue";
import { formatDate } from "@/util/date.js";
import { getStatusLabel } from "@/services/ordersService";
import { toSnakeCase, capitalizeFirstLetter } from "@/util/strings";
import { Select, Option, Tag, MessageBox } from "element-ui";
import { Dialog } from "element-ui";
import SubmitButton from "src/components/Buttons/SubmitButton.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules.umd";
import UserComments from "./UserComments/UserComments.vue";
import TextCounter from "./TextCounter.vue";
import LinkBuilder from "@/components/Toolbars/LinkBuilder/LinkBuilder.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import SelectableText from "@/components/Containers/SelectableText.vue";
import PageUrlCreateForm from "src/pages/Pages/ControlPanel/PageUrl/PageUrlCreateForm.vue";
import TaskAssignmentReview from "../../../TaskAssignment/TaskAssignmentReview.vue";
import TaskAssignmentMetaData from "../../../Tools/ToolsComponent/TaskAssignmentMetaData.vue";
import TranslationSidebar from "@/components/GeneralTranslate/TranslationSidebar.vue";
import TrentinoRegenerationSidebar from "@/components/TrentinoRegenerationSidebar/TrentinoRegenerationSidebar.vue";
import EditorLight from "@/components/Inputs/EditorLight.vue";
import { BaseInput, BaseTextarea } from "@/components/index";

extend("required", required);

export default {
  name: "ContentDetails",
  mixins: [orderAutosave],
  components: {
    EditorLight,
    SelectableText,
    LinkBuilder,
    BreadCrumb,
    BreadCrumbItem,
    AudioContent,
    ImageContent,
    TextContent,
    BaseTextarea,
    VideoContent,
    ContentToolbar,
    TextCounter,
    TaskAssignment,
    TaskAssignmentReview,
    TaskAssignmentMetaData,
    TranslationSidebar,
    TrentinoRegenerationSidebar,
    [Tag.name]: Tag,
    [Option.name]: Option,
    [Select.name]: Select,
    [MessageBox.name]: MessageBox,
    [Dialog.name]: Dialog,
    SubmitButton,
    UserComments,
    PageUrlCreateForm,
    BaseInput,
  },
  data() {
    return {
      loaded: false,
      isSticky: false,
      toggleLinkBuilder: false,
      toggleConfirmDialog: false,
      dialogRequestReview: false,
      dialogReject: false,
      form: {
        reject_note: "",
      },
      selectedLinkBuilderWord: "",
      showCommentsComponent: false,
      showSidebarTranslation:false,
      showPageUrlDialogPageUrl: null,
      showPageUrlDialogComponentKey: 0,
      showPageUrlDialogVisible: false,

      editFieldName: "",
      editFieldValue: "",
      editFieldValueHtml: "",
      editFieldComponentKey: 0,
      soft_keyword: "",
      soft_keywords: [],
      heading2 : "",
      headings : [],
    };
  },
  computed: {
    ...mapGetters({
      order: "getOrder",
      task: "getTask",
      taskHistory: "getTaskHistory",
      getEditingArea: "getEditingArea",
      getUserExtraInfo: "getUserExtraInfo",
      selectedWorkspace: "selectedWorkspace",
      getTools: "getTools",
    }),
    createdAt() {
      return this.order?.created_at ? formatDate(this.order.created_at) : "-";
    },
    status() {
      if (this.order?.admin_status == "admin_deny_reject") {
        return toSnakeCase(getStatusLabel("failed"));
      }
      return this.order ? toSnakeCase(getStatusLabel(this.order.status)) : "";
    },
    statusLabel() {
      if (this.order?.admin_status == "admin_deny_reject") {
        return capitalizeFirstLetter(getStatusLabel("failed"));
      }
      return this.order
        ? capitalizeFirstLetter(getStatusLabel(this.order.status))
        : "";
    },
    contentComponentName() {
      let category;

      switch (this.order?.category) {
        case "media":
          if (
            this.endsWithAny(this.order.content, ["jpg", "jpeg", "png", "gif"])
          ) {
            category = "image";
          } else if (this.endsWithAny(this.order.content, ["mp3"])) {
            category = "audio";
          } else if (this.endsWithAny(this.order.content, ["mp4"])) {
            category = "video";
          }
          break;
        case "text":
        default:
          category = "text";
      }

      if (category) {
        return `${capitalizeFirstLetter(category)}Content`;
      }

      return null;
    },
    isOrderDelivered() {
      if (this.order?.status == "delivered") {
        return true;
      }
      return false;
    },
    isAdminStatus() {
      return this.order?.admin_status && this.order?.status == "expired"
        ? true
        : false;
    },

    userCanUseComments() {
      return (
        this.showCommentsComponent &&
        !this.toggleLinkBuilder &&
        this.order?.category == "text"
      );
      /* if (window.innerWidth <= 1024 || this.order?.category !== 'text') {
        return false
      }
      return true */
    },
    originalOrderDetailId() {
      if (this.order && this.order.sub_orders && Array.isArray(this.order.sub_orders)) {
        const original = this.order.sub_orders.find(
          (sub) => sub.language === 'it' || (sub.json_data && sub.json_data.translate_into === '')
        );
        console.log(original)
        return original?.order_detail_id || null;
      }
      return null;
    },
    currentInfoTool() {
      if (this.getTools && this.order?.product_key) {
        return this.getTools.find(
          (tool) => tool.slug === this.order.product_key
        );
      }
      return null;
    },
    isTrentinoTool() {
      return ['web_article', 'press_release', 'dem_generator', 'microcopy_social'].includes(this.order?.product_key);
    },
  },
  watch: {
    unsavedContent(isChanged) {
      if (
        this.task &&
        !this.order.status.includes([
          "waitinaccg_generation",
          "waiting_queue",
          "failed",
        ])
      ) {
        if (isChanged) {
          window.onbeforeunload = function () {
            return "";
          };
          window.close = function () {
            return "";
          };
        } else {
          window.onbeforeunload = function () {
            return;
          };
          window.close = function () {
            return;
          };
        }
      }
    },
    'order.title'(newTitle) {
      if (newTitle) {
        document.title = `${newTitle} | Enterprise Contents.com`;
      }
    }
  },
  methods: {
    ...mapMutations([
      "setKeyword",
      "setSelection",
      "setOccurrences",
      "setOrder",
      "setSuggestedLinks",
      "setCustomUrl",
    ]),

    handleKeywordSelected(selectableTextResult) {
      this.setKeyword(selectableTextResult.range.toString());
      this.setSuggestedLinks([]);
      this.setCustomUrl(null);
      this.setOccurrences(selectableTextResult.occurrences);
      this.setSelection(selectableTextResult.range);
    },

    endsWithAny(inputString, suffixes) {
      return suffixes.some((suffix) => inputString.endsWith(suffix));
    },

    async humanOrderDelivered(action) {
      this.$preloader.fadeIn();
      let orderParams = [];
      (orderParams.order_detail_id = this.order.order_detail_id),
        (orderParams.action = action);
      if (action == "review" || action == "reject") {
        orderParams.reject_note = this.form.reject_note;
      }
      console.log(orderParams);
      await this.$store.dispatch("updateOrder", { ...orderParams });
      this.$preloader.fadeOut();
      this.$message({
        showClose: true,
        message: "Content Updated",
        type: "success",
      });
      const params = {
        id: this.$route.params.order_detail_id,
      };
      await this.$store.dispatch("fetchOrder", params);
      this.form.reject_note = "";
      this.dialogReject = false;
      this.dialogRequestReview = false;
    },

    handleShowPageUrlDialog(pageUrlObj) {
      this.showPageUrlDialogPageUrl = pageUrlObj;
      this.showPageUrlDialogVisible = true;
      this.showPageUrlDialogComponentKey++;
    },
    handleHidePageUrlDialog() {
      this.showPageUrlDialogVisible = false;
    },
    handleChangedPageUrl(pageUrlObj) {
      this.task.page_url = pageUrlObj;
    },
    handleEditFieldShowDialog(name, value) {
      this.editFieldName = name;
      if (this.editFieldName === 'soft_keywords') {
        this.soft_keywords = Array.isArray(value) ? [...value] : [];
      } else if (this.editFieldName === 'headings') {
        this.headings = Array.isArray(value) ? [...value] : [];
      } else if (this.editFieldName === 'additional_content') {
        this.editFieldValueHtml = value;
      } else {
        this.editFieldValue = value;
      }
      this.editFieldComponentKey++;
    },
    handleEditFieldResetDialog() {
      this.editFieldName = "";
      this.editFieldValue = "";
      this.editFieldValueHtml = "";
      this.soft_keywords = [];
      this.headings = [];
      this.editFieldComponentKey++;
    },
    async handleUpdateField() {
      this.$preloader.fadeIn();
      let value;
      if (this.editFieldName === 'additional_content') {
        value = this.editFieldValueHtml;
      } else if (this.editFieldName === 'soft_keywords') {
        value = this.soft_keywords;
      } else if (this.editFieldName === 'headings') {
        value = this.headings;
      } else {
        value = this.editFieldValue;
      }
      await this.$store.dispatch("updateTaskField", {
        user_id: this.$store.getters.getUser.id,
        order_detail_id: this.order.order_detail_id,
        [this.editFieldName]: value
      });
      this.$preloader.fadeOut();
      this.handleEditFieldResetDialog();
    },
    async loadTranslationSidebarIfApplicable() {
      if (!this.order?.order_detail_id || this.order?.language !== 'it') {
        this.showSidebarTranslation = false;
        return;
      }

      try {
        const response = await this.$store.dispatch("showTranslationSidebar", {
          order_detail_id: this.order.order_detail_id,
          user_id: this.$store.getters.getUser.id,
        });
        console.log('response', response)
        this.showSidebarTranslation = response?.data?.data?.users?.some(
          (user) => user.id === this.$store.getters.getUser.id
        );
      } catch (error) {
        console.error("Errore caricando sidebar traduzione:", error);
        this.showSidebarTranslation = false;
      }
    },
    addH2(h2) {
      this.heading2 = "";
      const h2AlreadyExists = this.headings.includes(h2);
      if (!h2AlreadyExists && h2 != "") {
        this.headings.push(h2);
      }
    },
    removeH2(h2) {
      this.headings = this.headings.filter((h) => h !== h2);
    },
    addSoftKeyword(sk) {
      this.soft_keyword = "";
      const skAlreadyExists = this.soft_keywords.includes(sk);
      if (!skAlreadyExists && sk != "") {
        this.soft_keywords.push(sk);
      }
    },
    removeSoftKeyword(sk) {
      this.soft_keywords = this.soft_keywords.filter((s) => s !== sk);
    },
    async onRegenerated() {
      try {
        await this.$store.dispatch('fetchOrder', {
          id: this.$route.params.order_detail_id,
        });
        this.resetAutosaveBaseline();
        this.$message({ type: 'success', message: 'Contenuto rigenerato con successo!' });
      } catch (error) {
        console.error('Errore durante la rigenerazione:', error);
        this.$message({ type: 'error', message: 'Errore durante la rigenerazione.' });
      }
    },
  },
  async created() {
    this.$store.commit("clearModuleOrders");
    const params = {
      id: this.$route.params.order_detail_id,
    };
    await this.$store.dispatch("fetchOrder", params);

    if (this.$route.query.showLinkBuilder === "1") {
      this.toggleLinkBuilder = true;
    }

    // Media orders need to execute the getMediaOrder call
    if (this.order.category === "media") {
      params.category = this.order.category; // param need by the api call
      await this.$store.dispatch("fetchOrder", params);
    }

    // Carica i tool nello store se non sono già presenti, in modo che currentInfoTool possa trovarli
    // Assicurati che la tua azione 'fetchTools' carichi tutti i tool necessari.
    if (!this.getTools || this.getTools.length === 0) {
      await this.$store.dispatch("fetchTools");
    }

    await this.loadTranslationSidebarIfApplicable();

    // TODO change with template->has_task_assignment, all'ordine deve essere passato il parametro has task assignment
    // oppure passare il task con l'ordine

    /* if(this.tools.some(t => t.slug === this.order?.product_key && t.has_task_assignment)) {
      await this.$store.dispatch('fetchTask', this.$route.params.order_detail_id);
    } */
    if (
      ["category_cards", "category_cards_manual", "demo_social_media_post", "demo_newsletter", "demo_product_description", "demo_blog_article"].includes(
        this.order?.product_key,
      )
    ) {
      // console.log("templates");
      // console.log(this.templates);
      await this.$store.dispatch(
        "fetchTask",
        this.$route.params.order_detail_id,
      );
      this.isSticky = true;
    }

    this.resetAutosaveBaseline();

    this.loaded = true;
  },
  beforeDestroy() {
    window.onbeforeunload = function () {
      return;
    };
    window.close = function () {
      return;
    };
    this.$store.commit("setKeyword", null);
    this.$store.commit("setSource", []);
    this.$store.commit("setSuggestedLinks", []);
  },
  async beforeRouteLeave(to, from, next) {
    await this.flushAutosave();

    if (
      this.task &&
      !this.order.status.includes([
        "waiting_generation",
        "waiting_queue",
        "failed",
      ]) &&
      this.unsavedContent
    ) {
      MessageBox.confirm(
        "All changes will be lost if you leave now. Do you want to continue? ",
        "Are you sure you want to leave without saving your work?",
        {
          confirmButtonText: "Continue Editing",
          cancelButtonText: "Yes, close",
        },
      )
        .then((_) => {
          next(false);
        })
        .catch((_) => {
          (this.unsavedContent = false), next();
        });
    } else {
      next();
    }
  },
};
</script>

<style lang="scss">
/* 992px = breakpoint `lg` di Bootstrap: sotto questa soglia le due colonne
   sono impilate e devono scorrere insieme alla pagina. Prima era 991px e a
   quella larghezza esatta i pannelli diventavano scrollabili pur essendo
   ancora a tutta larghezza. */
@media screen and (min-width: 992px) {
  .label {
      height: 24px;
  }

  /* I due pannelli (contenuto a sinistra, sidebar a destra) scrollano in modo
     indipendente, ognuno con la propria scrollbar visibile. */
  .content-pane.scrollable,
  .sidebar-content.scrollable {
    overflow-y: auto;
    height: 85vh;
    margin-bottom: 30px;
    padding-bottom: 0 !important;

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: #c2cbdf transparent;

    &::-webkit-scrollbar {
      width: 8px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #c2cbdf;
      border-radius: 6px;

      &:hover {
        background: #a9b4cd;
      }
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }

  .sidebar-content.scrollable {
    // la sidebar non deve mai scorrere in orizzontale: il contenuto va a capo.
    // (`overflow-y: auto` da solo renderebbe `overflow-x` calcolato = auto,
    // facendo comparire una scrollbar orizzontale al minimo debordamento)
    overflow-x: hidden;
    box-shadow: 0px 20px 20px -20px #0000001a, 0px 20px 20px -20px #0000001a;
  }
  .notice {
    background-color: #fff3cd;
    color: #000;
    border-radius: 10px;
    padding: 20px;
    width: fit-content;
    display: flex;
    align-items: flex-start;
    gap: 15px;
  }
  .notice-icon {
    background-color: white;
    border-radius: 50%;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffcc00;
    font-size: 20px;
    flex-shrink: 0;
    box-shadow: 0 0 2px rgba(0,0,0,0.1);
  }
  .notice-text {
    max-width: 400px;
  }
  .notice-text strong {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .notice-text a {
    display: inline-block;
    margin-top: 8px;
    color: #000;
    font-weight: bold;
    text-decoration: underline;
  }
}
</style>
